import { Box } from '@primer/react';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../state/reducers';
import { ePageBaseStatus } from '../../../models/ePageBaseStatus';
import { actions } from '../../../state/actions/actionsWrapper';
import LegalGroupList from './LegalGroupList';
interface ILegalViewPageProps {
    isShowPhoneFrame?: boolean,
    lan?: string
}
const LegalViewPage = (props: ILegalViewPageProps) => {
    const { status: groupStatus } = useSelector((x: RootState) => x.legalDocument.group)
    const { status: documentStatus } = useSelector((x: RootState) => x.legalDocument.documents)
    const dispatch = useDispatch();
    useEffect(() => {
        if (groupStatus === ePageBaseStatus.is_not_initialization || groupStatus === ePageBaseStatus.is_need_reload) {
            dispatch(actions.legalDocument.group.LOAD_START(undefined))
        }
    }, [groupStatus])
    useEffect(() => {
        if (documentStatus === ePageBaseStatus.is_not_initialization || documentStatus === ePageBaseStatus.is_need_reload) {
            dispatch(actions.legalDocument.document.LOAD_START(undefined))
        }
    }, [documentStatus])


    return (
        <>
            {props.isShowPhoneFrame === false &&
                <Box sx={{
                    p: 3
                }}>
                    <LegalGroupList lan={props.lan} />
                </Box>
            }
            {props.isShowPhoneFrame !== false &&
                <Box className='phone-frame'>
                    <Box sx={{
                        backgroundColor: "#fff",
                        flex: 1,
                        p: 3,
                        pt: 4,
                        borderRadius: "20px",
                        height: "750px",
                        overflowY: "auto",
                        mr: -2,
                        pr: 4
                    }}>
                        <LegalGroupList />
                    </Box>
                </Box>
            }
        </>

    );
};

export default LegalViewPage;